import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "main-center",
  role: "main"
}

import {computed, onMounted, reactive} from "vue";

import {useMainStore} from "@/stores/mainStore";

import NavbarMenu from "@/components/NavbarMenu.vue";
import MaskModal from "@/components/MaskModal.vue";
import AlertPopup from "@/components/AlertPopup.vue";
import DialogModal from "@/components/DialogModal.vue";
import AckPopup from "@/components/AckPopup.vue";
import LoginModal from "@/components/LoginModal.vue";
import TermsModal from "@/components/TermsModal.vue";
import CookiesModal from "@/components/CookiesModal.vue";
import AdminNavbar from "@/components/admin/AdminNavbar.vue";
import SubscribeNewsletterModal from "@/components/SubscribeNewsletterModal.vue";
import MaiALauncher from "@/components/MaiALauncher.vue";


interface State {
    isUserLogged: boolean
}

// eslint-disable-next-line

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const components = {NavbarMenu, AlertPopup, MaskModal, DialogModal, AckPopup, LoginModal, TermsModal, CookiesModal}

const mainStore = useMainStore();


const state: State = reactive({
    isUserLogged: computed<boolean>(() => !!mainStore.getLoggedUser),
})

onMounted(() => {
    mainStore.loadWhoAmI();
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavbarMenu),
    (state.isUserLogged)
      ? (_openBlock(), _createBlock(AdminNavbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(MaiALauncher),
    _createVNode(MaskModal),
    _createVNode(AlertPopup),
    _createVNode(DialogModal),
    _createVNode(AckPopup),
    (_unref(mainStore).isShowLogin)
      ? (_openBlock(), _createBlock(LoginModal, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(mainStore).isShowTerms)
      ? (_openBlock(), _createBlock(TermsModal, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(mainStore).isShowCookies)
      ? (_openBlock(), _createBlock(CookiesModal, { key: 3 }))
      : _createCommentVNode("", true),
    _createVNode(SubscribeNewsletterModal)
  ], 64))
}
}

})